import React from 'react';

import Typography from '../../../../../../library/typography/typography';
import MinimumPriceMessage from '../../../../../../components/minimum-price-message/minimum-price-message';
import ProductDescription from '../../../../../../components/product-description/product-description';
import ProductQuantity from '../../../../../../components/product-quantity/product-quantity';
import QuantityDisclaimer from '../../../../../../components/quantity-disclaimer/quantity-disclaimer';
import ProductListCardPrice from '../../../product-list-card-price/product-list-card-price.one-dt';

import { useMyAccount } from '../../../../../../shared/hooks/hooks';

import {
  getNormalizedProductType,
  getShouldShowMinimumPriceMessage,
  getStrikethroughInstantSavingsInfo
} from '../../../../../../shared/utils/product/product';

import { ProductData } from '../../../../../../shared/types/graphql-types';

import './product-list-staggered-card-axle.one-dt.scss';

interface ProductListStaggeredCardAxleProps {
  label: string;
  onQuantityChange: (e: Event, number) => void;
  product: ProductData;
  quantity: number;
  totalQuantity: number;
}

function ProductListStaggeredCardAxle(
  props: ProductListStaggeredCardAxleProps
) {
  const { label, onQuantityChange, product, quantity, totalQuantity } = props;

  const { isLoggedIn } = useMyAccount();
  const { mapDisplayRule, size } = product || {};

  const productType = getNormalizedProductType(product?.productType);

  const { instantStrikethroughSavingsPerProduct = 0 } =
    getStrikethroughInstantSavingsInfo(product, isLoggedIn, quantity);
  const showInstantMinimumPriceMessage =
    process.env.__FF_INSTANT_PRICE_STRIKE_THROUGH__ === 'true' &&
    instantStrikethroughSavingsPerProduct
      ? !isLoggedIn
      : true;
  const showMinimumPriceMessage =
    showInstantMinimumPriceMessage && getShouldShowMinimumPriceMessage(product);

  return (
    <div styleName="container">
      <Typography styleName="label" tag="span">
        {label}:&nbsp; <ProductDescription size={size} />
      </Typography>

      <div styleName="price-qty-container">
        <div styleName="price-container">
          <ProductListCardPrice
            hideInstantPromo
            hidePercentageSaved
            product={product}
            quantity={quantity}
            totalQuantity={totalQuantity}
          />
        </div>

        <ProductQuantity
          defaultValue={2}
          id="quantity"
          isHorizontal
          max={2}
          onBlur={onQuantityChange}
          onChange={onQuantityChange}
          showLabel
          value={quantity}
        />
      </div>
      {showMinimumPriceMessage && (
        <MinimumPriceMessage message={mapDisplayRule?.message} />
      )}
      <QuantityDisclaimer
        productType={productType}
        quantity={quantity}
        styleName="quantity-disclaimer"
      />
    </div>
  );
}

export default ProductListStaggeredCardAxle;
